<template>
	<SOSlotBase
		:bg-white="true"
	>
		<template v-slot:title-bar>
			<SOTitleBar
				v-if="!isOpenCamera"
				:page-title="pageSetting.pageTitle"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="flex-100 w-limit">
				<div class="flex-1">
					<div class="p-x-20 p-y-8 f-regular f-14 f-c-midgrey border-bottom">
						Dari: {{ rekeningBankDetail.nama }} - {{ rekeningBankDetail.nomor_rekening }}
					</div>

					<div class="p-x-20 p-y-16">
						<SOInputNominal
							v-if="!isOpenCamera"
							:title="'Nominal'"
							:required="true"
							:default-value="transferKasBank.nominal.formatted"
							:placeholder="'123.456'"
							:prefix-left="true"
							:prefix="'Rp'"
							v-model="transferKasBank.nominal"
							@input="(val) => { transferKasBank.nominal = val; pageSetting.editedNominal = true }"
						/>
						<ErrorMessage
							v-if="!isOpenCamera && pageSetting.editedNominal"
							class="error p-d-16"
							label="Nominal"
							:validation="$v.transferKasBank.nominal.formatted"
						/>

						<SOInputSelect
							v-if="!isOpenCamera"
							:title="'Tujuan Transfer'"
							:placeholder="'Pilih akun...'"
							:options="optionTujuanTransfer"
							:required="true"
							:selected="transferKasBank.tujuanTransfer"
							@option-selected="(val) => { transferKasBank.tujuanTransfer = val }"
						/>
						<ErrorMessage
							v-if="!isOpenCamera"
							class="error p-d-16"
							label="Nominal"
							:validation="$v.transferKasBank.tujuanTransfer"
						/>

						<SOInputDateTime
							v-if="!isOpenCamera"
							:title="'Waktu transfer'"
							:required="true"
							:id="'start-date'"
							:placeholder="'Tanggal Awal'"
							:max-date="$moment().format('YYYY-MM-DD') + 'T' + $moment().format('HH:mm')"
							:value="transferKasBank.waktuTransfer"
							@get-date="(v) => {transferKasBank.waktuTransfer = v}"
						/>
						<ErrorMessage
							v-if="!isOpenCamera"
							class="error p-d-16"
							label="Nominal"
							:validation="$v.transferKasBank.waktuTransfer"
						/>

						<SOInputRegular
							v-if="!isOpenCamera"
							class="p-d-16"
							:title="'Keterangan (opsional)'"
							:placeholder="'Keterangan...'"
							:validation="'alphanumeric'"
							v-model="transferKasBank.keterangan"
						/>

						<div>
							<div
								id="camera-2-content"
								:class="{fullScreen: isOpenCamera, }"
							>
								<SOUploadNota
									ref="uploadBuktiTransfer"
									label="Bukti mutasi rekening"
									id="camera-2"
									:images="uploadBuktiTransfer"
									:camera-open="camera.open"
									:full-size="camera.fullSize"
									:preview-img="selectedPreview"
									@setCamera="onToggleOpen"
									@setFullSize="onToggleFullSize"
									@setImages="setImages($event)"
									@deleteImg="onDeleteImg($event)"
									@preview="onSelected($event)"
									@hook:mounted="reloadImage"
								/>
								<div class="f-regular f-12 f-c-midgrey m-t-4">Sebagai bukti transfer rekening bank.
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="p-d-24 w-limit" v-if="!isOpenCamera">
					<div class="p-x-20 p-y-16">
						<SOButton
							:text="'Simpan'"
							:primary="true"
							:full="true"
							:disable="pageSetting.btn.save.disabled"
							:loading="pageSetting.btn.save.loading"
							@action="create"
						/>
					</div>
				</div>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOUploadNota from "@/so-components/global/ui/SOUploadNota.vue";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOButton from "@/so-components/global/ui/SOButton";
import {minLength, required} from "vuelidate/lib/validators";

export default {
	name: "RekeningBankTransferKas",
	components: {
		SOSlotBase,
		SOTitleBar,
		SOInputNominal,
		SOInputSelect,
		SOInputDateTime,
		SOInputRegular,
		SOUploadNota,
		ErrorMessage,
		SOButton,
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			rekeningBankDetail: "getRekeningBankDetail",
			akunKeuangan: "getAkunKeuangan",
		}),
		isOpenCamera() {
			return this.camera.open || this.camera.fullSize;
		},
	},
	data() {
		return {
			id: "",

			uploadBuktiTransfer: [],
			camera: {
				open: false,
				fullSize: false,
			},
			selectedPreview: null,

			pageSetting: {
				pageTitle: "Transfer Kas Bank",
				btn: {
					save: {
						loading: false,
						disabled: false,
					}
				},
				editedNominal: false,
			},
			transferKasBank: {
				nominal: {
					raw: 0,
					formatted: "",
				},
				tujuanTransfer: "",
				waktuTransfer: this.$moment().format('YYYY-MM-DD') + 'T' + this.$moment().format('HH:mm'),
				keterangan: "",
			},
			optionTujuanTransfer: [],
		}
	},
	validations: {
		transferKasBank: {
			nominal: {
				formatted: {
					required,
				}
			},
			tujuanTransfer: {
				required,
			},
			waktuTransfer: {
				required,
			},
		},
	},
	mounted() {
		this.id = this.$route.params.id
		this.getDetail()
		this.getAkunKeuangan()
	},
	methods: {
		back() {
			this.$router.back()
		},
		errorValidation() {
			this.$v.transferKasBank.nominal.formatted.$touch()
			this.$v.transferKasBank.tujuanTransfer.$touch()
			this.$v.transferKasBank.waktuTransfer.$touch()
			return this.$v.transferKasBank.nominal.formatted.$invalid ||
				this.$v.transferKasBank.tujuanTransfer.$invalid ||
				this.$v.transferKasBank.waktuTransfer.$invalid
		},
		async getDetail() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankDetail", this.id)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.back()
			}
		},
		async getAkunKeuangan() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("rekeningBankModule/fetchAkunKeuangan", "")
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.akunKeuangan.forEach(v => {
				this.optionTujuanTransfer = [...this.optionTujuanTransfer, {
					id: v.idakun,
					text: v.nama_akun,
				}]
			})
		},

		onToggleOpen(val, cam) {
			this.camera.open = !this.camera.open;
			this.isExpandBiaya = true;
		},
		onToggleFullSize(val, cam) {
			this.camera.fullSize = !this.camera.fullSize;
			this.isExpandBiaya = true;
		},
		setImages(data, target) {
			this[target] = data;
		},
		onDeleteImg(idx) {
			this.uploadBuktiTransfer.splice(idx, 1);
		},
		onSelected(idx) {
			this.selectedPreview = idx;
		},
		reloadImage() {
			this.$refs.uploadBuktiTransfer.handleImages();
		},

		async create() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			let form = new FormData
			form.append("idrekening_owner", this.rekeningBankDetail.id)
			form.append("idakun_debit", this.transferKasBank.tujuanTransfer)
			form.append("nominal", this.transferKasBank.nominal.raw)
			form.append("waktu_transfer", this.transferKasBank.waktuTransfer.replace("T", " ") + ":00")
			this.uploadBuktiTransfer.forEach(v => {
				form.append("bukti_transfer", v)
			})
            if (this.transferKasBank.keterangan !== '') {
                form.append("keterangan", this.transferKasBank.keterangan)
            }
			this.pageSetting.btn.save.loading = true
			this.pageSetting.btn.save.disabled = true
			const res = await this.$store.dispatch("rekeningBankModule/createTransferKas", form)
			this.pageSetting.btn.save.loading = false
			this.pageSetting.btn.save.disabled = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.$toast.success(res.msg)
			this.back()
		},
	}
}
</script>

<style scoped>
.fullScreen {
	padding-left: 0px;
	padding-right: 0px;
	margin-top: -95px;
	margin-left: -20px;
	position: absolute;
	width: 100vw;
	z-index: 200;
}
</style>